import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { BaseComponent } from '../../../BaseComponent';
import { getImgUrlExterior } from '../../../../modules/Vehicles/helpers';
import { selectWorks } from '../../../../modules/Api/selectors';
import {
  REQUEST_VEHICLE_DOCUMENTS_BY_TYPE,
  REQUEST_VEHICLES_DOCUMENTS_BY_TYPE,
} from '../../../../modules/Vehicles/constants';
import { getDocumentsByType } from '../../../../modules/Vehicles/actions';
import { Loader } from '../../../Loader';
import cn from 'classnames';
import { selectVehicleDocs } from '../../../../modules/Vehicles/selectors';

const Container = styled.div`
  min-width: 150px;
  max-width: 350px;
  min-height: 50px;
  margin: 6px;
  position: relative;

 .avatarImg {
  max-width: 100%; /* Ensures the image doesn't exceed container size */
  height: auto; /* Maintains aspect ratio */
  display: block; /* Removes inline-block spacing */
  margin: auto; /* Centers the image */
}

.img-overviewcard,
.img-infocard,
.img {
  background-size: contain; /* Ensures the whole image is visible */
  background-position: center center; /* Centers the image */
  background-repeat: no-repeat; /* Avoids repeated patterns */
  width: 100%; /* Makes the container responsive */
  height: 90px; /* Adjusts height based on width */
margin-top: -12px;
margin-bottom: -12px;
}

.img-overviewcard {
  height: 150px; /* Default height for larger screens */
}

@media (max-width: 768px) {
  .img-overviewcard {
    height: 150px; /* Adjust height for tablets */
  }
}

@media (max-width: 450px) {
  .img-overviewcard {
    height: 100px; /* Adjust height for mobile screens */
  }
}

}

`;

class VehicleAvatarComp extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      leftFrontImage: null,
    };
  }

  componentDidMount() {
    const { autoLoadPhotos, getPhotos } = this.props;
    if (autoLoadPhotos) {
      getPhotos((result) => {
        if (result?.length && result[0]?.id) {
          this.setState({ leftFrontImage: result[0] });
        }
      });
    }
  }

  getAvatarStyle = () => {
    const { location1 } = this.props;
    switch (location1) {
      case 'infoCard':
        return 'img-infocard';
      case 'overviewCard':
        return 'img-overviewcard';
      default:
        return 'img';
    }
  };
  render() {
    const { className, vehicle, onClick, work, photos, autoLoadPhotos } = this.props;
    const { leftFrontImage } = this.state;
    const avatarStyle = this.getAvatarStyle();

    if (work || (!photos && !autoLoadPhotos)) {
      return <Loader small />;
    }

    const image = leftFrontImage || photos?.[0];

    if (image?.id) {
      return (

        <Container className={cn('avatar', className)} vehicle={vehicle} onClick={onClick}>
        <div
          className={cn(avatarStyle, className)}
          style={{
            backgroundImage: `url('${encodeURI(decodeURI(image?.url)).replace(/%5C/g, '/')}')`,
             //backgroundImage: `url('https://autowientjestest.vindat.nl/storage/documents/89ba55af-cac3-4b31-bd3e-6a2489e0e266.JPG')`,
          }}
        />
      </Container>


      );
    }

    const placeholderImage =
      vehicle?.action_ws2_interior_inspection_done === '1'
        ? `url('${encodeURI(
            decodeURI(getImgUrlExterior(vehicle?.helga_id || vehicle?.id, '01'))
          ).replace(/%5C/g, '/')}')`
        : `url('/public/images/placeholder.png')`;

    return (
      <Container className={cn('avatar', className)} vehicle={vehicle} onClick={onClick}>
        <div
          className={cn('img', 'bottom', className)}
          style={{
            backgroundImage: placeholderImage,
          }}
        ></div>
      </Container>
    );
  }
}

VehicleAvatarComp.propTypes = {
  autoLoadPhotos: PropTypes.bool,
  className: PropTypes.string,
  vehicle: PropTypes.object,
  onClick: PropTypes.func,
  work: PropTypes.any,
  photos: PropTypes.array,
  getPhotos: PropTypes.func.isRequired,
  location1: PropTypes.string,
};

VehicleAvatarComp.defaultProps = {
  autoLoadPhotos: true,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_VEHICLE_DOCUMENTS_BY_TYPE}-${ownProps.vehicle?.id}`]),
    photos: selectVehicleDocs(ownProps.vehicle?.id),
  });

const mapDispatchToProps = (dispatch, ownProps) => ({
  getPhotos: (callback) =>
    dispatch(getDocumentsByType(ownProps.vehicle?.id, 'photo_interior_general_0left_front', callback)),
});

export const VehicleAvatar = compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(VehicleAvatarComp);
